<template>
    <div>
        <div class="layout-right bg mb16">
            <Form :label-width="98">
                <Row :gutter="24">
                    <Col span="8">
                        <Form-item label="投保公司">
                            <Input v-model.trim="params.applicantInfo" clearable placeholder="请输入投保公司" @on-enter="search"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="订单编号">
                            <Input v-model.trim="params.orderNo" clearable placeholder="请输入订单编号" @on-enter="search"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="关联保单号">
                            <Input v-model.trim="params.cntrNo" clearable placeholder="请输入关联保单号" @on-enter="search"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="订单状态">
                            <Select v-model="params.orderStatus" clearable>
                                <Option v-for="(item,index) in list" :value="item.value" :key="index">{{ item.label }}</Option>
                            </Select>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="发票状态">
                            <Select v-model="params.invoiceStatus" clearable>
                                <Option value="ISSUED">已申请</Option>
                                <Option value="NOT">未申请</Option>
                                <Option value="INVOICING">申请中</Option>
                            </Select>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="订单类型">
                            <Select v-model="params.polarity" clearable>
                                <Option value="POSITIVE">购买</Option>
                                <Option value="NEGATIVE">退款</Option>
                            </Select>
                        </Form-item>
                    </Col>
                    <Col span="24" class="right">
                        <Button type="primary" @click="search">搜索</Button>
                    </Col>
                </Row>
            </Form>
        </div>
        <div class="layout-right bg">
            <i-table :columns="columns" url="/broker/order/list.json" :params="params" ref="table">
                <template slot-scope="{ row }" slot="invoiceStatus">
                    <span v-if="row.invoiceStatus=='NOT'">未申请</span>
                    <span v-else-if="row.invoiceStatus=='INVOICING'">申请中</span>
                    <span v-else-if="row.invoiceStatus=='ISSUED'">已申请</span>
                </template>
                <template slot-scope="{ row }" slot="action">
                    <Dropdown transfer>
                        <a href="javascript:void(0)">
                            管理
                            <Icon type="ios-arrow-down"></Icon>
                        </a>
                        <Dropdown-menu slot="list">
                            <Dropdown-item @click.native="toDetail(row)" style="text-align: center;">
                                <a>查看详情</a>
                            </Dropdown-item>
                            <Dropdown-item  v-if="row.invoiceUrl" style="text-align: center;">
                                <a :href="row.invoiceUrl" target="_blank">下载发票</a>
                            </Dropdown-item>
                            <!-- <Dropdown-item  v-if="row.orderStatus=='PAID'&&row.invoiceUrl&&row.invoiceStatus=='ISSUED'" style="text-align: center;">
                                <a :href="row.invoiceUrl" target="_blank">下载发票</a>
                            </Dropdown-item> -->
                            <!-- <Dropdown-item v-if="row.orderStatus=='PAID'&&(row.invoiceStatus=='NOT'||row.invoiceStatus=='INVOICING')" @click.native="toInvoice(row)" style="text-align: center;">
                                <a>{{ row.invoiceStatus=='INVOICING' ? '查询开票进度' : '申请开票'}}</a>
                            </Dropdown-item> -->
                        </Dropdown-menu>
                    </Dropdown>
                </template>
            </i-table>
        </div>
        <Modal v-model="invoiceShow" title="发票信息" width="600px" :mask-closable="false">
			<Form :model="invoiceForm" ref="invoiceForm" :label-width="120" :rules="invoiceFormRules">
                <FormItem label="发票信息" prop="invoiceType">
					<RadioGroup v-model="invoiceForm.invoiceType" @on-change="invoiceTypeChange">
                        <Radio label="PLAIN">普票（电子）</Radio>
                        <Radio label="VAT">专票（纸质）</Radio>
                    </RadioGroup>
				</FormItem>
				<FormItem label="公司名称" prop="invoiceName" :rules="invoiceForm.invoiceType == 'VAT'? invoiceFormRules.invoiceName: [{ required: false }]">
					<Input type="text" disabled  v-model="invoiceForm.invoiceName"></Input>
				</FormItem>
				<FormItem label="统一社会信用代码" prop="invoiceUniqueCode" :rules="invoiceForm.invoiceType == 'VAT'? invoiceFormRules.invoiceUniqueCode: [{ required: false }]">
					<Input type="text" disabled v-model="invoiceForm.invoiceUniqueCode"></Input>
				</FormItem>
				<FormItem label="开户地址" prop="invoiceAddress" :rules="invoiceForm.invoiceType == 'VAT'? invoiceFormRules.invoiceAddress: [{ required: false }]">
					<Input type="text" v-model="invoiceForm.invoiceAddress" placeholder="请输入开户地址" :maxlength="50"></Input>
				</FormItem>
				<FormItem label="联系电话" prop="invoicePhone" :rules="invoiceForm.invoiceType == 'VAT'? invoiceFormRules.invoicePhone: [{ required: false }]">
					<Input type="text" v-model="invoiceForm.invoicePhone" placeholder="请输入联系电话" :maxlength="20"></Input>
				</FormItem>
                <FormItem label="开户行" prop="openingBankName" :rules="invoiceForm.invoiceType == 'VAT'? invoiceFormRules.openingBankName: [{ required: false }]">
					<Input type="text" v-model="invoiceForm.openingBankName" placeholder="请输入开户行" :maxlength="30"></Input>
				</FormItem>
                <FormItem label="对公账号" prop="openingBankAccount" :rules="invoiceForm.invoiceType == 'VAT'? invoiceFormRules.openingBankAccount: [{ required: false }]">
					<Input type="text" v-model="invoiceForm.openingBankAccount" placeholder="请输入对公账号" :maxlength="30"></Input>
				</FormItem>
                <FormItem label="电子邮箱" prop="invoiceDeliverEmail" :rules="invoiceForm.invoiceType == 'VAT'? invoiceFormRules.invoiceDeliverEmail: [{ required: false }]">
					<Input type="text" v-model="invoiceForm.invoiceDeliverEmail" placeholder="请输入电子邮箱" :maxlength="100"></Input>
				</FormItem>
                <FormItem label="邮寄地址" prop="invoiceDeliverAddress" :rules="invoiceForm.invoiceType == 'VAT'? invoiceFormRules.invoiceDeliverAddress: [{ required: false }]">
					<Input type="text" placeholder="填写内容需要包含邮寄人姓名、电话与邮寄地址" v-model="invoiceForm.invoiceDeliverAddress" :maxlength="100"></Input>
				</FormItem>
			</Form>
			<template slot="footer">
				<Button type="text" @click="cancalInvoice">取消</Button>
				<Button type="primary" @click="handleSubmit('invoiceForm')">确定</Button>
			</template>
		</Modal>
    </div>
    </template>
    <script>
    import { mapState } from 'vuex'
    import ITable from '../../../companyGroupEmployerDadi/common/ITable'
    export default {
        components:{ ITable },
        data () {
            return {
                loading: false,
                params: {
                    bizId:'INDUSTRY_ENTERPRISE',
                    orderStatus:'',
                    orderNo:''
                },
                columns: [
                    {title:'订单编号',key:'orderNo',width: 260,fixed: 'left'},
                    {title:'关联保单号',key:'policyNo',width: 260},
                    {title:'订单创建时间',key:'createTime',width: 180},
                    {title:'投保公司',key:'applicantName',width: 180,ellipsis: true,tooltip: true},
                    {title:'产品名称',key:'productName',width: 180,ellipsis: true,tooltip: true},
                    {title:'保险公司',key:'companyName',width: 180,ellipsis: true,tooltip: true},
                    {title:'订单状态',key:'orderStatusDesc',width: 120},
                    {title:'保费（元）',key:'totalAmount',width: 140,align: 'right'},
                    // {title:'佣金（元）',key:'createTime',width: 180},
                    {title:'订单支付时间',key:'paymentTime',width: 180},
                    {title:'订单类型',key:'polarityDesc',width: 120},
                    {title:'发票状态',slot:'invoiceStatus',width: 120},
                    {
                        title: '操作',
                        slot: 'action',
                        width: 90,
                        align: 'center',
                        fixed: 'right'
                    }
                ],
                list:[
                    {
                        value: 'UNPAID',
                        label: '待支付'
                    },
                    {
                        value: 'PAID',
                        label: '已支付'
                    },
                    {
                        value: 'PAID_NEED_CONFIRM',
                        label: '已支付待确认'
                    },
                    {
                        value: 'CLOSED',
                        label: '已关闭'
                    }
                ],
                invoiceShow:false,
                invoiceForm:{
                    invoiceType:'PLAIN'
                },
                invoiceFormRules:{
                    invoiceName:{required:true,message:'请输入开票名称',trigger:'blur'},
                    invoiceUniqueCode:{required:true,message:'请输入统一社会信用代码',trigger:'blur'},
                    invoiceAddress:{required:true,message:'请输入开户地址',trigger:'blur'},
                    invoicePhone:{required:true,message:'请输入联系电话',trigger:'blur'},
                    openingBankName:{required:true,message:'请输入开户行',trigger:'blur'},
                    openingBankAccount:{required:true,message:'请输入对公账号',trigger:'blur'},
                    invoiceDeliverEmail:[
                        { required: true, message: '邮箱不能为空', trigger: 'blur' },
                        { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
                    ],
                    invoiceDeliverAddress:{required:true,message:'请输入邮寄地址',trigger:'blur'}
                }
            }
        },
        computed:{
            ...mapState({
                channelId: state=>state.common.channelInfo.id,
            })
        },
        created () {
        },
        methods:{
            handleSubmit (name) {
                if(this.invoiceForm.invoiceType=='VAT'){
                    this.$refs[name].validate((valid) => {
                        if (valid) {
                            this.$axios.post('/broker/order/downloadInvoice.json',{
                                ...this.invoiceForm
                            }).then(res=>{
                                this.$Message.success('申请成功!');
                                this.cancalInvoice()
                            }).catch(err=>{
                                this.cancalInvoice()
				            })
                        }
                    })
                } else {
                    let reg=/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                    if(this.invoiceForm.invoiceDeliverEmail&&(this.invoiceForm.invoiceDeliverEmail!==''&&!reg.test(this.invoiceForm.invoiceDeliverEmail))) { 
                        this.$Message.error('请输入有效的邮箱');
                        return
                    }
                    this.$axios.post('/broker/order/downloadInvoice.json',{
                        ...this.invoiceForm
                    }).then(res=>{
                        this.$Message.success('申请成功!');
                        this.cancalInvoice()
                    })
                }
            },
            cancalInvoice(){
                this.invoiceShow = false;
                this.invoiceForm = {
                    invoiceType:'PLAIN'
                }
                this.search()
            },
            invoiceTypeChange(){
                // this.$refs.invoiceForm.resetFields();
            },
            toInvoice(row){
                if(row.invoiceInfo&&row.invoiceInfo.invoiceType=='NOT'){
                    this.invoiceShow = true;
                    this.$nextTick(()=>{
                        this.$set(this.invoiceForm,'invoiceName',row.applicantList[0].subjectName);
                        this.$set(this.invoiceForm,'invoiceUniqueCode',row.applicantList[0].idNumber);
                        this.$set(this.invoiceForm,'orderNo',row.orderNo);
                    })
                } else {
                    this.invoiceForm = row.invoiceInfo;
                    this.$set(this.invoiceForm,'orderNo',row.orderNo);
                    this.$axios.post('/broker/order/downloadInvoice.json',{
                        ...this.invoiceForm
                    }).then(res=>{
                        this.$Message.success('申请成功!');
                        this.invoiceForm = {
                            invoiceType:'PLAIN'
                        }
                        this.search();
                    }).catch(err=>{
                        this.invoiceForm = {
                            invoiceType:'PLAIN'
                        }
                    })
                }
            },
            search(){
                this.$refs.table.getList()
            },
            toDetail(row){
                this.$router.push({
                    path:`/my/customizedCCIC/orderDetail/${row.orderNo}`
                })
            }
        }
    }
    </script>
    <style lang="less" scoped>
    </style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedDadi/order/index.vue